import { createFileRoute } from "@tanstack/react-router";
import { useNavigate } from "@tanstack/react-router";
import { useContext, useEffect } from "react";
import { ConfigContext, OrderDataContext, ReturnOrderContext } from "@/Layout";
import { useReturnCreated } from "@/api/createReturn";
import NextButton from "@/components/NextButton/NextButton";
import { RefundMethod } from "@/components/RefundMethod/RefundMethod";
import { ReturnContainer } from "@/components/ReturnContainer/ReturnContainer";

const RefundMethodPage = () => {
  const { returnOrder } = useContext(ReturnOrderContext),
    { orderData } = useContext(OrderDataContext),
    configData = useContext(ConfigContext),
    navigate = useNavigate(),
    returnCreated = useReturnCreated();

  useEffect(() => {
    if (!configData || !orderData || !returnOrder)
      navigate({
        to: "/",
        search: (prev) => prev,
      });

    if (returnCreated) {
      navigate({
        to: "/confirm",
        search: (prev) => prev,
      });
    }
  }, [configData, orderData, returnOrder, returnCreated, navigate]);

  if (!configData || !orderData || !returnOrder)
    return navigate({
      to: "/",
      search: (prev) => prev,
    });

  return (
    <ReturnContainer>
      <div>
        <h1 className="font-semibold text-lg">
          {configData.refund_method_header}
        </h1>
        <p className="text-sm mt-2">{configData.refund_method_message}</p>
        <hr className="mt-4 mb-8" />
        <RefundMethod />
        <div className="mt-6 mb-6">
          <NextButton
            onClick={() =>
              navigate({
                to: "/confirm",
                search: (prev) => prev,
              })
            }
            text={configData.refund_method_button_message ?? "Next"}
            buttonDisabled={returnOrder.refund_as_gift_card === undefined}
            buttonColor={configData?.button_color}
          />
        </div>
      </div>
    </ReturnContainer>
  );
};

export const Route = createFileRoute("/refund-method")({
  component: RefundMethodPage,
});
